import ExternalService from '@/bundles/GroupFilters/services/ExternalService';
import { httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import ExternalToMapper from '@/bundles/GroupFilters/mappers/ExternalToMapper';

function externalServiceFactory () {
  return new ExternalService({
    transport: httpV2,
    errorMapper: new ErrorMapper(),
    cityMapper: new ExternalToMapper(),
  });
}

export const externalService = externalServiceFactory();
